import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_PLUVIO_TRACKING } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CampaignTracking from '../../../campaign/components/campaignTracking/CampaignTracking'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { useParams } from 'react-router'


const PluviometryCampaignTrackingApp = ({}) => {
    const {
        pluviometers,
    } = useSelector(store => ({
        pluviometers: store.PluviometryReducer.pluviometers,
    }), shallowEqual)

    const dispatch = useDispatch()
    const { id } = useParams()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_PLUVIO_TRACKING)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.fetchPluviometryCampaignEvent(id))
    }, [dispatch, id])

    return (
        <CampaignTracking
            stations={pluviometers}
            stationType='pluviometry'
        />
    )
}

export default PluviometryCampaignTrackingApp